import { User } from 'firebase'
import moment from 'moment'
import React, { FC, useEffect } from 'react'
import GenericIcon from '../../../GenericComponents/GenericIcon'

import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import UsersQueue from '../../../assets/REDESIGN_Assets/Conferences/room-users-queue.svg'
import RoomIcon from '../../../assets/REDESIGN_Assets/Conferences/room-icon.svg'

import {
  ConferencesScreenContainer,
  TestQueueBox,
  RoomTile,
  JoinToQueue,
  RoomQueueBoxContainer,
  QueueHeader,
  QueuedUser,
  QueuedUsersContainer,
  QuededUserheader,
  SessionContainer,
  SessionHeader,
  JoinRoomButton,
  QueueViewContainer,
  ConferenceMainHeader,
  ConferenceSubHeader,
  RoomTileBox,
  RoomRow,
  RoomHeader,
  RoomLightText,
  RoomBoldText,
  RoomUsersText,
  RoomJoinButton,
  Divider,
} from '../styles/ConferencesScreenStyles'
import GenericColumn from '../../../GenericComponents/GenericColumn'

interface QueueViewProps {
  handleUserJoinQueue: Function
  conference: any
  isUserInQueue: boolean
  userQueuedRoomKey: Number
  handleUserleaveQueue: Function
  getQueuedUsers: Function
  isRoomCreated: boolean
  redirectUserToConferenceRoom: Function
  isUserKicked: boolean
  isUserKickedBackend: boolean
  meeting: any
  attendee: any
  seletedMiazgaFolder: any
  selectedVideoId: number
  selectedVideo: any
  isSessionQueueOpen: any
  isFirstQueueOpen: any
  isSecondQueueOpen: any
  shouldQueueBeOpen: boolean
}

const QueueView: FC<QueueViewProps> = ({
  handleUserJoinQueue,
  conference,
  isUserInQueue,
  userQueuedRoomKey,
  handleUserleaveQueue,
  getQueuedUsers,
  isRoomCreated,
  redirectUserToConferenceRoom,
  isUserKicked,
  isUserKickedBackend,
  meeting,
  attendee,
  seletedMiazgaFolder,
  selectedVideoId,
  selectedVideo,
  isSessionQueueOpen,
  isFirstQueueOpen,
  isSecondQueueOpen,
  shouldQueueBeOpen,
}) => {
  useEffect(() => {
    validateQueueTime()
  }, [shouldQueueBeOpen])

  const isUserInThisQueue = (isUserInQueue: boolean, roomKey: Number) => {
    return isUserInQueue && userQueuedRoomKey === roomKey
  }

  const getTargetRooms = (roomKey: number) => {
    return (
      conference &&
      conference.rooms.filter((room: any) => room.video_id == roomKey)
    )
  }

  const countUsers = (roomKey: number) => {
    if (conference.rooms[roomKey].users) {
    }
  }

  const getVideoStartTime = (roomKey: number) => {
    return moment(
      conference.sessions[conference.rooms[roomKey].session_id].start_video
    ).format('HH:mm')
  }
  const getQueueStartTime = (roomKey: number) => {
    return conference.sessions[conference.rooms[roomKey].session_id].start_date
  }

  const formatQueueUsers = (roomKey: number) => {
    let users: any = []
    let usersString: string = ''

    if (conference.rooms[roomKey].users) {
      for (const key of Object.keys(conference.rooms[roomKey].users)) {
        // users[...users,conference.rooms[roomKey].users[key]]

        if (conference.rooms[roomKey].users[key].user_name) {
          users.push(conference.rooms[roomKey].users[key].user_name)
        }
      }
    }

    if (users) {
      users.forEach((user: any, i: any) => {
        if (i === users.length - 1) {
          usersString += `${user}`
        } else {
          usersString += ` ${user} / `
        }
      })
    }

    return usersString
  }

  const validateQueueTime = () => {
    let queueTime: string = ''

    if (conference && conference.sessions) {
      if (
        moment().valueOf() >
        moment(conference.sessions[0].redirect_users_date).valueOf()
      ) {
        queueTime = 'after'
      }

      if (
        moment().valueOf() >
          moment(conference.sessions[0].start_date).valueOf() &&
        moment().valueOf() <
          moment(conference.sessions[0].redirect_users_date).valueOf()
      ) {
        queueTime = 'between'
      }
      if (
        moment().valueOf() < moment(conference.sessions[0].start_date).valueOf()
      ) {
        queueTime = 'before'
      }

      return queueTime
    }
  }

  return (
    <GenericMainCard flexDir={'column'} className="standard">
      <GenericRow margin={'3vh 0 2vh 0'}>
        <GenericTextSpan fSize={'1.6rem'} fWeight="bold">
          Treningi wspólne
        </GenericTextSpan>
      </GenericRow>

      <GenericRow margin={'0 0 2vh 0'}>
        <GenericTextSpan fSize={'1.1rem'}>
          Dzisiejsze treningi MIAZGA Live
        </GenericTextSpan>
      </GenericRow>

      {selectedVideoId || selectedVideoId === 0 ? (
        <div
          style={{
            maxHeight: '60vh',
            overflow: 'auto',
            width: '80%',
            padding: '0 5%',
          }}
        >
          <GenericRow margin={'0vh 0 1vh 0'}>
            <GenericTextSpan>
              Pamiętaj, aby mieć działającą kameę oraz mikrofon
            </GenericTextSpan>
          </GenericRow>

          {getTargetRooms(selectedVideoId).map((room: any) =>
            room.session_id === 0 &&
            room.miazga_id === seletedMiazgaFolder.albumId - 6 ? (
              // First tile row
              <RoomTileBox>
                <GenericRow width={'100%'}>
                  <GenericRow width={'33%'}>
                    <GenericTextSpan
                      fSize={'1.1rem'}
                      fWeight={'bold'}
                      tAlign={'left'}
                    >
                      {selectedVideo.name}
                    </GenericTextSpan>
                  </GenericRow>

                  <GenericRow width={'33%'}>
                    <GenericIcon
                      width={'0.9rem'}
                      height={'0.9rem'}
                      src={UsersQueue}
                    />
                    <GenericTextSpan fSize={'0.85rem'}>
                      {getQueuedUsers(room).length}/6
                    </GenericTextSpan>
                  </GenericRow>

                  <GenericRow width={'33%'}>
                    <GenericIcon
                      width={'0.9rem'}
                      height={'0.9rem'}
                      src={RoomIcon}
                    />
                    <GenericTextSpan>
                      Pokój {room.key % 5 == 0 ? '5' : room.key % 5}
                    </GenericTextSpan>
                  </GenericRow>
                </GenericRow>

                {/* Second tile row */}
                <GenericRow margin={'2vh 0 1vh 0'}>
                  <GenericTextSpan>
                    {formatQueueUsers(room.key)}
                  </GenericTextSpan>
                </GenericRow>
                <Divider />
                <GenericRow>
                  <GenericColumn width={'50%'}>
                    <GenericRow justify="flex-start" margin={'6% 0'}>
                      <GenericTextSpan fSize={'0.85rem'}>
                        otwarcie kolejki
                      </GenericTextSpan>
                      <GenericTextSpan margin={'0 0 0 5px'} fSize={'0.85rem'}>
                        {moment(conference.sessions[0].start_date).format(
                          'HH:mm'
                        )}
                      </GenericTextSpan>
                    </GenericRow>
                    <GenericRow justify="flex-start" margin={'3% 0'}>
                      <GenericTextSpan fSize={'0.85rem'}>
                        zamknięcie kolejki
                      </GenericTextSpan>
                      <GenericTextSpan margin={'0 0 0 5px'} fSize={'0.85rem'}>
                        {moment(
                          conference.sessions[0].redirect_users_date
                        ).format('HH:mm')}
                      </GenericTextSpan>
                    </GenericRow>
                    <GenericRow justify="flex-start" margin={'3% 0'}>
                      <GenericTextSpan fSize={'0.85rem'}>start</GenericTextSpan>
                      <GenericTextSpan fSize={'0.85rem'} margin={'0 0 0 5px'}>
                        {moment(conference.sessions[0].start_video).format(
                          'HH:mm'
                        )}
                      </GenericTextSpan>
                    </GenericRow>
                  </GenericColumn>
                  <GenericColumn
                    width={'50%'}
                    height={'100%'}
                    align={'flex-end'}
                    justify={'flex-end'}
                  >
                    <RoomJoinButton
                      className={
                        shouldQueueBeOpen &&
                        getQueuedUsers(room).length < 6 &&
                        (!isUserInQueue ||
                          isUserInThisQueue(isUserInQueue, room.key)) &&
                        'active'
                      }
                      onClick={() =>
                        isUserInQueue &&
                        shouldQueueBeOpen &&
                        !isUserInThisQueue(isUserInQueue, room.key)
                          ? null
                          : isUserInThisQueue(isUserInQueue, room.key) &&
                            shouldQueueBeOpen &&
                            getQueuedUsers(room).length < 6
                          ? handleUserleaveQueue(room.key)
                          : shouldQueueBeOpen && getQueuedUsers(room).length < 6
                          ? handleUserJoinQueue(room.key)
                          : null
                      }
                    >
                      {isUserInThisQueue(isUserInQueue, room.key)
                        ? 'Wyjdź'
                        : 'Dołącz do kolejki'}
                    </RoomJoinButton>
                  </GenericColumn>
                </GenericRow>
              </RoomTileBox>
            ) : null
          )}
        </div>
      ) : (
        <GenericRow margin={'1vh 0 3vh 0'}>
          <GenericTextSpan opacity={'0.7'} fSize={'0.9rem'}>
            Wybierz trening z listy po lewej stronie
          </GenericTextSpan>
        </GenericRow>
      )}

      {/* <ConferenceSubHeader>Nadchodzące treningi</ConferenceSubHeader>

      {selectedVideoId || selectedVideoId == 0 ? (
        <div>
          {getTargetRooms(selectedVideoId).map(
            (room: any) =>
              room.session_id === 1 &&
              room.miazga_id === seletedMiazgaFolder.albumId - 6 && (
                <RoomTileBox>
                  <RoomRow width={'100%'}>
                    <RoomHeader>
                      {selectedVideo.name} / pokój{' '}
                      {room.key % 5 == 0 ? '5' : room.key % 5}
                    </RoomHeader>
                  </RoomRow>
                  <RoomRow
                    width={'33%'}
                    margin={'3% 0 0 0'}
                    alignItems={'center'}
                  >
                    <RoomLightText>Start treningu: </RoomLightText>
                    <RoomBoldText>{getVideoStartTime(room.key)}</RoomBoldText>
                  </RoomRow>

                  <RoomRow
                    width={'33%'}
                    margin={'3% 0 0 0'}
                    alignItems={'center'}
                    justify={'center'}
                  >
                    <RoomLightText>Uczestników: </RoomLightText>
                    <RoomBoldText>
                      {' '}
                      {getQueuedUsers(room).length}/6
                    </RoomBoldText>
                  </RoomRow>
                  <RoomRow
                    width={'33%'}
                    margin={'2% 0 0 0'}
                    alignItems={'center'}
                  >
                    {(isUserInThisQueue(isUserInQueue, room.key) &&
                      !isUserKicked &&
                      !isUserKickedBackend) ||
                    (!isUserInQueue &&
                      !isUserKicked &&
                      !isUserKickedBackend) ? (
                      <RoomJoinButton
                        className={isSecondQueueOpen && 'active'}
                        onClick={() =>
                          isUserInThisQueue(isUserInQueue, room.key) &&
                          isSecondQueueOpen
                            ? handleUserleaveQueue(room.key)
                            : isSecondQueueOpen
                            ? handleUserJoinQueue(room.key)
                            : null
                        }
                      >
                        {isUserInThisQueue(isUserInQueue, room.key)
                          ? 'WYJDŹ'
                          : 'DOŁąCZ'}
                      </RoomJoinButton>
                    ) : null}
                  </RoomRow>

                  <RoomRow
                    width={'100%'}
                    margin={'3% 0 0 0'}
                    alignItems={'center'}
                  >
                    <RoomUsersText>{formatQueueUsers(room.key)}</RoomUsersText>
                  </RoomRow>
                </RoomTileBox>
              )
          )}
        </div>
      ) : (
        <div>Prosze wybrac trening</div>
      )} */}
    </GenericMainCard>
  )
}

export default QueueView
